<script setup>
import { onMounted, computed } from 'vue';
import { useConsentStore } from '@/Stores/consentStore';

const consentStore = useConsentStore();

const showBanner = computed(() => consentStore.shouldShowBanner());

onMounted(() => {
    consentStore.initialize();
});

function handleAcceptAll() {
    consentStore.acceptAll();
}

function handleAcceptAnalytics() {
    consentStore.acceptAnalyticsOnly();
}

function handleDeny() {
    consentStore.denyAll();
}
</script>

<template>
    <Transition name="slide-up">
        <div
            v-if="showBanner"
            class="fixed bottom-0 left-0 right-0 z-50 p-4 bg-gray-900 border-t border-gray-700 shadow-lg"
        >
            <div class="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                <div class="text-sm text-gray-300 text-center sm:text-left">
                    <p>
                        We use cookies to analyze site usage and improve your experience.
                        <a
                            href="/privacy"
                            class="text-blue-400 hover:text-blue-300 underline"
                            target="_blank"
                        >
                            Learn more
                        </a>
                    </p>
                </div>
                <div class="flex flex-wrap items-center justify-center gap-2">
                    <button
                        @click="handleDeny"
                        class="px-4 py-2 text-xs font-semibold text-gray-400 hover:text-gray-200 transition-colors"
                    >
                        Deny
                    </button>
                    <button
                        @click="handleAcceptAnalytics"
                        class="px-4 py-2 bg-gray-700 border border-gray-600 rounded-md text-xs font-semibold text-white hover:bg-gray-600 transition-colors"
                    >
                        Analytics Only
                    </button>
                    <button
                        @click="handleAcceptAll"
                        class="px-4 py-2 bg-blue-600 border border-transparent rounded-md text-xs font-semibold text-white hover:bg-blue-500 transition-colors"
                    >
                        Accept All
                    </button>
                </div>
            </div>
        </div>
    </Transition>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
</style>
